import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import { AdminRoles } from '../../util/uiconstants';

export default function getAdminUsersreducer(state = initialState.adminUsers, action) {
	switch (action.type) {
		case types.GET_ADMIN_USERS: {
			return action.response && action.response.length > 0 && action.response?.sort((a, b) =>
				a.firstName?.toUpperCase() + ' ' + a.lastName?.toUpperCase() >
					b.firstName?.toUpperCase() + ' ' + b.lastName?.toUpperCase()
					? 1
					: -1
			).map(x => {
				return {
					...x, userRole: x.isAdminReader ? AdminRoles.find(x => x.value === 'IsAdminReader') :
						x.isAdminWriter ? AdminRoles.find(x => x.value === 'IsAdminWriter') : x.isSuperAdmin ?
							AdminRoles.find(x => x.value === 'IsSuperAdmin') : null
				}
			});
		}
		case types.CLEAR_ADMIN_USERS: {
			return initialState.adminUsers;
		}
		default:
			return state;
	}
}
